module.exports = __webpack_public_path__ + "mo/img/swiper_bg03.ad7ce8cc.png";